/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';
import router from '@/router/index';

function comparePoints(a, b) {
  if (a.points < b.points) {
    return 1;
  }
  if (a.points > b.points) {
    return -1;
  }
  return 0;
}

const initialState = () => ({
  application_rankings: [],
  application_popup: {},
  applicationSuccess: false,
  error: '',
  loading: false,
  key_ranking: {}
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getApplicationRanking: (state) => (payload) => {
    return state.application_rankings.find(application_ranking => application_ranking.id === payload.id);
  },
  getApplicationRankings: (state) => state.application_rankings,
  getApplicationSuccess: (state) => state.applicationSuccess,
  getApplicationPopup: (state) => state.application_popup,
  getApplicationKeyRanking: (state) => state.key_ranking,
  isLoading: (state) => state.loading
};
// Actions
const actions = {
  updateApplicationPopupComment({commit}, comment){
    commit('update_application_popup_comment', comment);
  },
  acceptApplication({
    commit
  }, payload) {
    commit('set_loading', true);
    axios({
        url: 'applicationrankings/' + payload.id + '/acceptapplication',
        method: 'DELETE',
        data: { role: payload.role }
      })
      .then(resp => {
        if (resp.status === 204) {
          commit('remove_application', payload.id);
          commit('set_loading', false);
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
      });
  },
  declineApplication({
    commit
  }, application_ranking) {
    commit('set_loading', true);
    axios({
        url: 'applications/' + application_ranking.application_id,
        method: 'DELETE'
      })
      .then(resp => {
        if (resp.status === 204) {
          commit('remove_application', application_ranking.id);
          commit('set_loading', false);
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
      });
  },
  apply({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'applications',
        method: 'POST',
        data: payload.application
      })
      .then(() => {

        commit('set_application_success', true);
        resolve();


        // if (payload.images.length === 0) {
          // commit('set_application_success', true);
        // } else {
          // let promises = [];
          // for (let i = 0; i < payload.images; i++) {
          //   // resp.data.data.application.user.projects[i]
          //   promises.push(axios({
          //     url: 'applicationrankings/' + resp.data.data.application.user.projects[i].project.id + '/imageupload?verification_key=' + resp.data.data.verification_key,
          //     data: payload.images[i],
          //     headers: { 'Content-Type': 'multipart/form-data' }
          //   }));
          // }
          // Promise.all(promises)
          // .then( () => {
            // commit('set_application_success', true);
          // })
          // .catch( image_err => {
            // commit('set_error', extractErrorDetails(image_err));
          // });
        // }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject(extractErrorDetails(err));
      });
    });
  },
  requestOneApplicationRanking({commit}, id){
    axios({
      url: 'applicationrankings/' + id +'?show=showWithEntities',
      method: 'GET',
      headers: {'Cache-Control': 'no-cache'}
    })
    .then(resp => {
      commit('set_application_popup', resp.data.data);
      commit('View/set_application_popup_dialog', true, { root: true });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  requestApplicationRankings({
    commit
  }) {
    return new Promise((resolve, reject) => {
      commit('set_loading', true);
      axios({
          url: 'applicationrankings?show=showForRankings',
          method: 'GET',
          headers: {'Cache-Control': 'no-cache'}
        })
        .then(resp => {
          commit('set_application_rankings', resp.data.data);
          commit('set_loading', false);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('set_loading', false);
          reject();
        });
    });
  },
  updatePoints({
    commit,
    getters
  }, payload) {
    commit('set_loading', true);
    axios({
        url: 'applicationrankings/' + payload.id,
        method: 'PUT',
        data: {
          points: payload.points
        }
      })
      .then(resp => {
        if (resp.status === 204) {
          let application = Object.assign({}, getters.getApplicationRanking(payload));
          application.points = payload.points;
          commit('update_points', application);
          commit('set_loading', false);
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
      });
  },
  updateStatus({
    commit,
    getters
  }, payload) {
    commit('set_loading', true);
    axios({
        url: 'applicationrankings/' + payload.id,
        method: 'PUT',
        data: {
          status: payload.status
        }
      })
      .then(resp => {
        if (resp.status === 204) {
          let application = Object.assign({}, getters.getApplicationRanking(payload));
          application.status = payload.status;
          commit('update_status', application);
          commit('set_loading', false);
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
      });
  },
  updateComment({
    commit,
    getters
  }, payload) {
    commit('set_loading', true);
    axios({
        url: 'applicationrankings/' + payload.id,
        method: 'PUT',
        data: {
          comment: payload.comment
        }
      })
      .then(resp => {
        if (resp.status === 204) {
          let application = Object.assign({}, getters.getApplicationRanking(payload));
          application.comment = payload.comment;
          commit('update_status', application);
          commit('set_loading', false);
        }
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
      });
  },
  requestApplicationRankingByKey({commit}, key){
    return new Promise((resolve, reject) => {
      axios({
        url: 'applicationrankings?verification_key='+key+'&show=showWithEntities',
        method: 'GET'
      })
      .then(resp => {
        commit('set_ranking', resp.data.data);
        resolve();
      })
      .catch(() => {
        router.push({ name: 'NotFound'});
        reject();
      });
    });
  }
};
// Mutations
const mutations = {
  remove_application(state, id) {
    const application_rankings = [
      ...state.application_rankings.filter(application_ranking => application_ranking.id !== id),
    ];
    state.application_rankings = application_rankings.sort(comparePoints);
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_application_rankings(state, payload) {
    state.application_rankings = payload;
  },
  set_application_success(state, boolean) {
    state.applicationSuccess = boolean;
  },
  set_error(state, err) {
    state.error = err;
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  set_application_popup(state, application){
    state.application_popup = application;
  },
  update_points(state, application) {
    const application_rankings = [
      ...state.application_rankings.filter(application_ranking => application_ranking.id !== application.id),
      application
    ];
    state.application_rankings = application_rankings.sort(comparePoints);
  },
  update_status(state, application) {
    const application_rankings = [
      ...state.application_rankings.filter(application_ranking => application_ranking.id !== application.id),
      application
    ];
    state.application_rankings = application_rankings.sort(comparePoints);
  },
  set_ranking(state, ranking){
    state.key_ranking = ranking;
  },
  update_application_popup_comment(state, comment){
    state.application_popup.comment = comment;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
